import { crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A quiz card: an authored `:::quiz` the learner answered in a lesson and now reviews. It is graded
 * by the answer rather than rated: a correct answer reviews it Easy, a wrong one Again.
 *
 * The card is identified by the quiz's catalogue UUID `key` (the same namespace as slide keys; see
 * `assets/slides`), and its row ids are derived from it (`deriveQuizCardRowIds`), so two devices
 * that answer the quiz before they sync create the same rows. That is why no unique index guards
 * `key` or `user_card_id`: sync cannot resolve a unique conflict, so the duplicate is made
 * impossible instead. The quiz's content (prompt, options, answer key) ships in the app bundle and
 * is looked up by `key`; a key the bundle no longer has leaves the card unservable, not broken.
 */
export const userQuizCardTable = crudTable(
  "user_quiz_card",
  {
    key: text("key").notNull(),
    // A parent id, not a FOREIGN KEY: see `ACTOR_TABLE_PARENTS` (the cloud copy would enforce one).
    userCardId: text("user_card_id").notNull(),
  },
  // `userCardId` backs the `userCard.userQuizCard` relation join; `key` backs the per-quiz lookups.
  (table) => [
    index("user_quiz_card_key_idx").on(table.key),
    index("user_quiz_card_user_card_id_idx").on(table.userCardId),
  ],
);

export type UserQuizCard = typeof userQuizCardTable.$inferSelect;
